import { render } from "./EntityManager.vue?vue&type=template&id=0ab4e259"
import script from "./EntityManager.vue?vue&type=script&lang=js"
export * from "./EntityManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__